import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import { ProcurementAxios } from "api/ProcurementAxios";
import { DistrictInChargeAxios } from "api/DistrictInChargeAxios";
import { WarehouseAxios } from "api/WarehouseAxios";

const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";

const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};

export const fetchPendingDispatch = createAsyncThunk(
  "itemInward/fetchPendingDispatch",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    listType,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    listType: string;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }
    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              // Handle cases like { from_date: ..., to_date: ... }
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params.append(key, String(value));
                }
                if (
                  (filterValue.from_date || filterValue.to_date) &&
                  (filterField === "created_at" || filterField === "updated_at")
                ) {
                  if (filterField === "created_at") {
                    filterField = "created";
                  } else {
                    filterField = "updated";
                  }
                  params.append("filter_by", filterField);
                }
              });
            } else {
              // Handle primitive values (string, number)
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }

    if (listType === "Item Request") {
      const response: any = await WarehouseAxios.get(
        `/dispatch/district-incharge/item-in/allocatoin-itemRequest-listing/?transfer_type=Item Request&${params.toString()}`
      );
      return {
        data: response?.data?.data || [],
        rowCount: response.data.count || 0,
      };
    } else if (listType === "Allocation") {
      const response: any = await WarehouseAxios.get(
        `/dispatch/district-incharge/item-in/allocatoin-itemRequest-listing/?transfer_type=Allocation&${params.toString()}`
      );
      return {
        data: response?.data?.data || [],
        rowCount: response.data.count || 0,
      };
    } else {
      const response: any = await DistrictInChargeAxios.get(
        `/dispatch/district_incharge_dispatch/status_delivered_filter/?${params.toString()}`
      );
      return {
        data: response?.data?.data || [],
        rowCount: response.data.count || 0,
      };
    }
    // console.log("response :", response);
  }
);

export const exportCSVPendingDispatch = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (filterField && filterValue !== undefined && filterValue !== null) {
          if (typeof filterValue === "object" && filterValue !== null) {
            Object.entries(filterValue).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
              if (
                (filterValue.from_date || filterValue.to_date) &&
                (filterField === "created_at" || filterField === "updated_at")
              ) {
                if (filterField === "created_at") {
                  filterField = "created";
                } else {
                  filterField = "updated";
                }
                params.append("filter_by", filterField);
              }
            });
          } else {
            params.append(filterField, filterValue);
          }
        }
      }
    );
  }

  const response = await DistrictInChargeAxios.get(
    `/dispatch/district_incharge_dispatch/packing_filter/?${params.toString()}`,
    {
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "PendingDispatch.csv",
  };
};

export const fetchAllDropdownsPendingDispatch = createAsyncThunk(
  "itemInward/fetchAllDropdownsPendingDispatch",
  async (column: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/approved-pr/droupdown_list/`, {
        params: { columns: column },
      });

      const dropdownData = response.data?.data || response.data || [];

      return { column, data: dropdownData };
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch dropdown");
    }
  }
);
